module.exports = __webpack_public_path__ + "img/guoqi.9fb207b1.png";